"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackVirtualPageView = void 0;
var dataLayer_1 = require("@ocm/services/dataLayer");
var trackVirtualPageView = function () {
    var _a;
    if (window.recommendationData) {
        (0, dataLayer_1.default)({ event: "virtualPageView", Recommendation: (_a = window.recommendationData) === null || _a === void 0 ? void 0 : _a.Recommendation });
    }
};
exports.trackVirtualPageView = trackVirtualPageView;
